import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
@Injectable({
  providedIn: 'root'
})
export class EmrService {

  api = `${environment.restAPIUrl}/api/public`
  constructor(private http:HttpClient) { }

  emrRegistration(obj){
    return this.http.post(`${this.api}/saveEMR`,obj);
  }
}
